import * as React from 'react';
import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import RequiredMark from '../../../../common/components/required-mark';
import TaxonomyField from '../../../../common/components/taxonomy-field';
import {
  FORM_SUBMITTER_ACTIONS,
  useFormSubmitterContext,
} from '../../form-submitter-context';
import type { TaxonomyFieldElement } from '../../../../types/form/Element';
import TaxonomyFetcherAPI from '../../../../api/TaxonomyFetcher';

type Props = {
  description?: React.ReactNode;
  element: TaxonomyFieldElement;
};

const TaxonomyFieldWithContext = (props: Props) => {
  const { element, description } = props;
  const {
    id,
    disabled,
    label,
    metadataFieldKey,
    metadataTemplateKey,
    required,
    scope,
    optionsRules,
  } = element;

  const {
    state,
    dispatch,
    selector: { getSelectedValuesForId, getErrorForId },
  } = useFormSubmitterContext();

  const values = getSelectedValuesForId(state, id);
  const error = getErrorForId(state, id);
  const { fileRequestId, isSameEnterprise, submitInProgress } = state;
  const isDisabled = submitInProgress;

  const onChange = useCallback(
    // @ts-expect-error [MIGRATION-SUPPRESSION]: TS7006
    newValues => {
      dispatch({
        id,
        type: FORM_SUBMITTER_ACTIONS.TAXONOMY_FIELD_ON_CHANGE,
        /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
        newValues: newValues?.map((value: any) => ({
          id: value.value,
          displayName: value.displayValue,
        })),
      });
    },
    [dispatch, id],
  );
  const renderLabel = required ? (
    <>
      {label} <RequiredMark />
    </>
  ) : (
    label
  );

  const fetcher = useCallback(
    // @ts-expect-error [MIGRATION-SUPPRESSION]: TS7031
    ({ searchInput }) =>
      TaxonomyFetcherAPI.getTaxonomyOptions({
        isSameEnterprise,
        fileRequestId,
        scope: scope || '',
        fieldKey: metadataFieldKey || '',
        templateKey: metadataTemplateKey || '',
        searchInput,
      }),
    [
      fileRequestId,
      isSameEnterprise,
      metadataFieldKey,
      metadataTemplateKey,
      scope,
    ],
  );

  return (
    <TaxonomyField
      description={description}
      error={error && <FormattedMessage {...error} />}
      fetcher={fetcher}
      isDisabled={disabled || isDisabled}
      isRequired={required}
      label={renderLabel}
      onChange={onChange}
      // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2322
      optionsRules={optionsRules}
      // @ts-expect-error [MIGRATION-SUPPRESSION]: TS7006
      value={(values || []).map(value => ({
        displayValue: value.displayName,
        value: value.id,
      }))}
      isSubmitter
    />
  );
};

export { TaxonomyFieldWithContext };
export default TaxonomyFieldWithContext;
